import styled from "styled-components";
import Header from "../components/Header";
import PostForm from "../components/modelPostPage/PostForm";
import { useNavigate } from "react-router-dom";
import { XIcon } from "../components/Icon";

const ModelPostPageContainer = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`;

const ModelPostPage = () => {
  const navigate = useNavigate();
  const handleClickExit = () => {
    navigate("/");
  };

  return (
    <ModelPostPageContainer>
      <Header leftChild={<XIcon />} headText="구인글 올리기" onClickLeftChild={handleClickExit} />
      <PostForm />
    </ModelPostPageContainer>
  );
};

export default ModelPostPage;